export default function ArticleGrid() {
  const articles = [
    {
      category: "Debt Settlement",
      title: "The Complete Guide to Debt Settlement in 2025",
      excerpt: "Everything you need to know about debt settlement, including how it works, potential risks, and whether it's right for your financial situation.",
      readTime: "8 min read",
      image: "https://public.readdy.ai/ai/img_res/a136fa0a015125111ba54b0b6ab3cf55.jpg",
      tags: ["Settlement", "Debt Relief", "Guide"]
    },
    {
      category: "Business Debt",
      title: "Breaking Free from Merchant Cash Advance Traps",
      excerpt: "Learn how to escape the cycle of expensive merchant cash advances and protect your business from predatory lending practices.",
      readTime: "6 min read",
      image: "https://readdy.ai/api/search-image?query=Business%20owner%20looking%20relieved%20while%20reviewing%20merchant%20cash%20advance%20documents%20with%20declining%20debt%20charts%2C%20modern%20office%20setting%20with%20laptop%20and%20financial%20statements&width=400&height=250&seq=article-002&orientation=landscape",
      tags: ["MCA", "Business", "Strategy"]
    },
    {
      category: "Credit Repair",
      title: "Rebuilding Your Credit After Debt Settlement",
      excerpt: "Step-by-step strategies to improve your credit score and financial standing after completing a debt settlement program.",
      readTime: "5 min read",
      image: "https://readdy.ai/api/search-image?query=Person%20checking%20improved%20credit%20score%20on%20smartphone%20with%20positive%20upward%20trending%20credit%20chart%2C%20clean%20modern%20setting%20with%20financial%20success%20symbols&width=400&height=250&seq=article-003&orientation=landscape",
      tags: ["Credit", "Recovery", "Tips"]
    },
    {
      category: "Financial Planning",
      title: "Creating an Emergency Fund While in Debt",
      excerpt: "How to build financial security and prepare for unexpected expenses even when dealing with existing debt obligations.",
      readTime: "7 min read",
      image: "https://readdy.ai/api/search-image?query=Organized%20savings%20jar%20with%20money%20and%20financial%20planning%20documents%2C%20calculator%20and%20budget%20worksheets%20on%20clean%20desk%2C%20representing%20emergency%20fund%20building&width=400&height=250&seq=article-004&orientation=landscape",
      tags: ["Savings", "Planning", "Security"]
    },
    {
      category: "Legal Rights",
      title: "Your Rights When Dealing with Debt Collectors",
      excerpt: "Know your legal protections under the Fair Debt Collection Practices Act and how to handle aggressive collection tactics.",
      readTime: "6 min read",
      image: "https://readdy.ai/api/search-image?query=Legal%20documents%20and%20gavel%20on%20professional%20desk%20with%20consumer%20protection%20papers%2C%20representing%20debt%20collection%20rights%20and%20legal%20protections&width=400&height=250&seq=article-005&orientation=landscape",
      tags: ["Legal", "Protection", "Rights"]
    },
    {
      category: "Small Business",
      title: "Alternative Financing Options for Struggling Businesses",
      excerpt: "Explore healthier financing alternatives to high-interest merchant cash advances and predatory business loans.",
      readTime: "9 min read",
      image: "https://readdy.ai/api/search-image?query=Small%20business%20owner%20reviewing%20various%20financing%20options%20with%20charts%20showing%20healthy%20business%20growth%2C%20modern%20office%20with%20positive%20financial%20documents&width=400&height=250&seq=article-006&orientation=landscape",
      tags: ["Financing", "Alternatives", "Growth"]
    },
    {
      category: "Tax Issues",
      title: "Understanding Tax Implications of Debt Settlement",
      excerpt: "Important information about potential tax consequences of settled debt and how to prepare for tax season.",
      readTime: "5 min read",
      image: "https://readdy.ai/api/search-image?query=Tax%20forms%20and%20documents%20with%20calculator%20showing%20debt%20settlement%20tax%20implications%2C%20organized%20desk%20with%20financial%20paperwork%20and%20professional%20setting&width=400&height=250&seq=article-007&orientation=landscape",
      tags: ["Taxes", "IRS", "Planning"]
    },
    {
      category: "Success Stories",
      title: "Real Client Success: From $85K Debt to Financial Freedom",
      excerpt: "Follow Maria's journey from overwhelming credit card debt to achieving complete financial freedom through our settlement program.",
      readTime: "4 min read",
      image: "https://readdy.ai/api/search-image?query=Happy%20family%20celebrating%20financial%20freedom%20with%20paid%20off%20debt%20documents%2C%20smiling%20people%20in%20comfortable%20home%20setting%20showing%20debt%20relief%20success&width=400&height=250&seq=article-008&orientation=landscape",
      tags: ["Success", "Case Study", "Inspiration"]
    },
    {
      category: "Budgeting",
      title: "The 50/30/20 Budget Rule for Debt Repayment",
      excerpt: "Learn how to adapt the popular budgeting method to accelerate your debt payoff while maintaining your quality of life.",
      readTime: "6 min read",
      image: "https://readdy.ai/api/search-image?query=Organized%20budget%20planner%20with%20percentage%20allocations%20and%20debt%20payoff%20calculator%2C%20clean%20workspace%20with%20financial%20planning%20tools%20and%20charts&width=400&height=250&seq=article-009&orientation=landscape",
      tags: ["Budgeting", "Strategy", "Planning"]
    }
  ];

  const categories = ["All", "Debt Settlement", "Business Debt", "Credit Repair", "Financial Planning", "Legal Rights"];

  return (
    <section id="articles" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Financial Education <span className="text-orange-500">Library</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Browse our collection of expert articles, guides, and resources designed to help you make informed financial decisions.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category, index) => (
            <button
              key={index}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
                index === 0 
                  ? 'bg-orange-500 text-white' 
                  : 'bg-white text-gray-600 hover:bg-orange-100 hover:text-orange-600'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {articles.map((article, index) => (
            <article key={index} className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group cursor-pointer">
              <div className="relative overflow-hidden">
                <img 
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-orange-600 transition-colors duration-300">
                  {article.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {article.excerpt}
                </p>
                
                <div className="flex items-center justify-between">
                  <div className="flex flex-wrap gap-2">
                    {article.tags.map((tag, tagIndex) => (
                      <span key={tagIndex} className="bg-gray-100 text-gray-600 px-2 py-1 rounded text-xs">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <span className="text-gray-500 text-sm">{article.readTime}</span>
                </div>
                
                <div className="mt-4 pt-4 border-t border-gray-100">
                  <button className="text-orange-500 hover:text-orange-600 font-semibold flex items-center space-x-2 transition-colors duration-300">
                    <span>Read Article</span>
                    <i className="fas fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Load More Button */}
        <div className="text-center mt-12">
          <button className="bg-white border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 whitespace-nowrap">
            Load More Articles
          </button>
        </div>
      </div>
    </section>
  );
}